module.exports = __webpack_public_path__ + "img/win.2defae07.png";